import {useBackground} from '~/common/FabricInvitation/EventCreateDesign/components/Background/actions/useBackground';
import {MobileBox} from '~/common/FabricInvitation/EventCreateDesign/components/Background/Mobile/Contents/MobileBox';
import {BackgroundColorPicker} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/ColorPicker/BackgroundColorPicker';
import {EditorContainer} from '~/common/FabricInvitation/EventCreateDesign/components/Container/Mobile/EditorContainer';
import {EditorIcons} from '~/common/FabricInvitation/EventCreateDesign/components/EditorIcons/EditorIcons';
import {useOverlay} from '~/common/OverlayAnimation/actions/useOverlay';
import './BackgroundEditorMobile.sass';

export const BackgroundEditorMobile = () => {
  const {backgroundIcons, onColorChange, onTextureChange, selectedBackground} = useBackground(true);
  const {onOverlayChange, overlayIcons, selectedOverlay} = useOverlay();

  return (
    <EditorContainer>
      <EditorContainer.Tab title="Backgrounds">
        <MobileBox animated>
          <div className="background-editor__body">
            <EditorIcons
              icons={[{component: <BackgroundColorPicker onColorChange={onColorChange} />}].concat(
                backgroundIcons
              )}
              className="background-editor__body__icons"
              onClick={onTextureChange}
              selectedIcon={selectedBackground?.icon}
              highlight={false}
              height={50}
              width={50}
              noPadding
            />
          </div>
        </MobileBox>
      </EditorContainer.Tab>
      <EditorContainer.Tab title="Effects">
        <MobileBox title="Effects">
          <EditorIcons
            icons={overlayIcons}
            selectedIcon={selectedOverlay}
            onClick={onOverlayChange}
            highlight={false}
            height={58}
            width={50}
            hideAnimatedIndicator
            className="editor-icons__effects--mobile"
            outline
          />
        </MobileBox>
      </EditorContainer.Tab>
    </EditorContainer>
  );
};
